// Console-error ring buffer for QA reports. Installed once at app boot (before the
// production console silencing in App.js) so every report can carry the last ~20
// errors the reporter actually hit.
const MAX_ENTRIES = 20;
const MAX_ENTRY_LENGTH = 500;

const buffer = [];
let installed = false;

const serializePart = (part) => {
  try {
    if (part instanceof Error) return `${part.name}: ${part.message}`;
    if (typeof part === "string") return part;
    return JSON.stringify(part);
  } catch (e) {
    return String(part);
  }
};

const push = (kind, parts) => {
  const text = parts.map(serializePart).join(" ").slice(0, MAX_ENTRY_LENGTH);
  buffer.push(`[${new Date().toISOString().slice(11, 19)}] ${kind}: ${text}`);
  if (buffer.length > MAX_ENTRIES) buffer.shift();
};

export const installQaConsole = () => {
  if (installed) return;
  installed = true;

  const originalError = console.error;
  console.error = function (...args) {
    push("console.error", args);
    return originalError.apply(console, args);
  };

  window.addEventListener("error", (event) => {
    push("window.onerror", [event?.message || "unknown error", event?.filename ? `(${event.filename}:${event.lineno})` : ""]);
  });

  window.addEventListener("unhandledrejection", (event) => {
    push("unhandledrejection", [event?.reason]);
  });
};

export const getQaConsoleErrors = () => [...buffer];
